import { actionType } from '../../constants/Menu';

export const selectMenuItem = menuItem => dispatch => {
  dispatch({
    type: actionType.SELECT_MENU_ITEM,
    payload: menuItem,
  });
};
